import { render, staticRenderFns } from "./PagePicker.vue?vue&type=template&id=e8831e74&scoped=true"
import script from "./PagePicker.vue?vue&type=script&lang=js"
export * from "./PagePicker.vue?vue&type=script&lang=js"
import style0 from "./PagePicker.vue?vue&type=style&index=0&id=e8831e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8831e74",
  null
  
)

export default component.exports